import { useState } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

import ReportCountries from './sidebar/ReportCountries';
import ReportMetrics from './sidebar/ReportMetrics';
import ReportPublishers from './sidebar/ReportPublishers';

/**
 * Main sidebar component for filtering dimensions and metrics
 * Features collapsible sections, search functionality
 * @returns {JSX.Element} Sidebar with dimension and metric filters
 */
export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = localStorage.getItem('sidebarCollapsed');
    return stored ? JSON.parse(stored) : false;
  });

  /**
   * Handle sidebar collapse
   * @param {boolean} collapsed
   */
  function handleCollapse(collapsed) {
    setIsCollapsed(collapsed);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed));
  }

  return (
    <div
      className={`hidden md:block ${isCollapsed ? 'w-12' : 'w-[17rem]'} min-h-screen py-4 px-2 relative transition-all duration-300 ease-in-out border-r rounded-r-lg bg-white`}
    >
      <button
        onClick={() => handleCollapse(!isCollapsed)}
        className="absolute -right-3 top-2 bg-base-100 border-2 border-black rounded-full p-1 hover:bg-base-200 z-10"
      >
        {isCollapsed ? (
          <ChevronRightIcon className="h-4 w-4" />
        ) : (
          <ChevronLeftIcon className="h-4 w-4 text-black" />
        )}
      </button>

      <div className={`space-y-4 ${isCollapsed ? 'hidden' : 'block'}`}>
        <ReportPublishers />

        <ReportCountries />

        <ReportMetrics />
      </div>
    </div>
  );
}
